export const dynamic = 'force-dynamic'
import React from 'react';
import urls from '@/utils/urls/urls';
import cl from '@/utils/console/cl';
import Image from 'next/image';
import AnimationWrapper from '@/components/AnimationWrapper/AnimationWrapper';
// import MessageContainer from '@/components/MessageFromManagement/MessageContainer';
import MessageFromManagement from '@/components/MessageFromManagement/MessageFromManagement';


const MessageManagementPage = async () => {

    // const aboutRes = await fetch('https://jsonplaceholder.typicode.com/todos')
    // const aboutRes = await fetch(urls?.about)
    const messageRes = await fetch(urls?.messageFromManagement, {
        cache: "no-cache"
        // cache: "no-store"
    })
    // console.log("aboutRes", aboutRes);
    // if (!messageRes.ok) {
    //     // console.log("messageRes has an Error", messageRes)
    // }
    // console.log("messageRes", messageRes)
    const messageData = await messageRes.json()
    // console.log("messageData", messageData)
    const message = Array.isArray(messageData?.data) ? messageData?.data : [];
    // console.log("about", about);

    return (
        <div className='bg-white'>
            {/* hi */}
            <MessageFromManagement messages={message} />
        </div>
    )

    // return (
    //     <>

    //         <div className="about-area py-120 bg-white">
    //             <div className="container">
    //                 <div className="row">
    //                     <div className="col-lg-6">
    //                         <AnimationWrapper animation="fade-left">
    //                             <div className="about-left wow fadeInLeft" data-wow-delay=".25s">
    //                                 <div className="about-img">
    //                                     <div className="row">
    //                                         <div className="col-6">
    //                                             <img
    //                                                 className="img-1"
    //                                                 // src="assets/img/choose/jersey.png"
    //                                                 src={urls?.image + about?.middle_img}
    //                                                 alt=""
    //                                             // width={260}
    //                                             // height={370}
    //                                             />
    //                                         </div>
    //                                         <div className="col-6">
    //                                             <img
    //                                                 className="img-2"
    //                                                 // src="assets/img/choose/fleece.png"
    //                                                 src={urls?.image + about?.side_img}
    //                                                 alt=""
    //                                             // width={260}
    //                                             // height={370}
    //                                             />
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                                 <div className="about-experience">
    //                                     {/* <p>We Have</p> */}
    //                                     <h5>
    //                                         {about?.experience}
    //                                         {/* With */}
    //                                         {/* 30<span>+</span> */}
    //                                     </h5>
    //                                     <p>Years Of Experience</p>
    //                                 </div>
    //                             </div>
    //                         </AnimationWrapper>
    //                     </div>
    //                     <div className="col-lg-6">
    //                         <AnimationWrapper animation="fade-right">
    //                             <div className="about-right wow fadeInUp" data-wow-delay=".25s">
    //                                 <div className="site-heading mb-3">
    //                                     <span className="site-title-tagline">
    //                                         <i className="far fa-solar-panel" /> About Us
    //                                     </span>
    //                                     <h2 className="site-title">
    //                                         {about?.title}
    //                                         {/* We Are The <span>Best</span> &amp; <span>Expert</span> For Your{" "}
    //                   <span>Solution</span> */}
    //                                     </h2>
    //                                 </div>
    //                                 <div className="about-text">
    //                                     {
    //                                         about?.description && <div dangerouslySetInnerHTML={{ __html: about?.description }} />
    //                                     }
    //                                     {/* At Tex Excellence Limited, we are dedicated to manufacturing precision-engineered, high-quality, and innovative custom-designed knitting machines. Our extensive product line not only includes state-of-the-art knitting machines but also offers OEM parts, expert technical service, and fabric design consultation across North America, Mexico, Central America, and South America. Our fabric range encompasses a wide array of applications, including T-shirts, fleece wear, sportswear, casual wear, industrial fabrics, medical fabrics, and packaging fabrics. */}
    //                                     {/* <br />
    //                 Through our unwavering commitment to excellence, we have consistently pursued total customer satisfaction. This dedication is demonstrated daily through our teamwork, drive, and the meticulous work ethic of our employees, who strive for precision in every project.
    //                 <br />
    //                 As the premier creator of large-diameter circular knitting machines in North America, our highly skilled engineering team continually invests in research and development to perfect and modernize our knitting technology. With offices in Mexico, Honduras, Colombia, and Brazil, we boast the largest presence of any machine manufacturer in the western hemisphere. Alongside our partners, we have representatives worldwide, ensuring that Tex Excellence Limited remains at the forefront of the knitting industry. */}
    //                                 </div>
    //                                 <div className="about-content">
    //                                     <div className="row g-3">
    //                                         {
    //                                             (!!about?.box1Title && !!about?.box1Description) && <div className="col-md-6">
    //                                                 <div className="about-item">
    //                                                     <div className="icon">
    //                                                         <img src="assets/img/icon/install.svg" alt="" />
    //                                                     </div>
    //                                                     <div className="content">
    //                                                         <h6>{about?.box1Title}</h6>
    //                                                         <p>{about?.box1Description}</p>
    //                                                     </div>
    //                                                 </div>
    //                                             </div>
    //                                         }
    //                                         {
    //                                             (!!about?.box2Title && !!about?.box2Description) && <div className="col-md-6">
    //                                                 <div className="about-item">
    //                                                     <div className="icon">
    //                                                         <img src="assets/img/icon/material.svg" alt="" />
    //                                                     </div>
    //                                                     <div className="content">
    //                                                         <h6>{about?.box2Title}</h6>
    //                                                         <p>{about?.box2Description}</p>
    //                                                     </div>
    //                                                 </div>
    //                                             </div>
    //                                         }

    //                                         {/* <div className="col-md-6">
    //                                         <div className="about-item">
    //                                             <div className="icon">
    //                                                 <img src="assets/img/icon/material.svg" alt="" />
    //                                             </div>
    //                                             <div className="content">
    //                                                 <h6>Quality Material</h6>
    //                                                 <p>Take a look at our up of the round shows</p>
    //                                             </div>
    //                                         </div>
    //                                     </div> */}
    //                                     </div>
    //                                 </div>
    //                                 <a href="about" className="theme-btn mt-4">
    //                                     Discover More
    //                                     <i className="fas fa-arrow-right" />
    //                                 </a>
    //                             </div>
    //                         </AnimationWrapper>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //         <div>
    //             {/* <AnimationWrapper animation="fade-right"></AnimationWrapper>
    //             <AnimationWrapper animation="fade-left" delay={0.2}></AnimationWrapper>
    //             <AnimationWrapper animation="fade-up" duration={1}></AnimationWrapper> */}
    //         </div>
    //     </>
    // );
};

export default MessageManagementPage;